import { render, staticRenderFns } from "./ListStudentsMiPE.vue?vue&type=template&id=d7dfbfdc&"
import script from "./ListStudentsMiPE.vue?vue&type=script&lang=js&"
export * from "./ListStudentsMiPE.vue?vue&type=script&lang=js&"
import style0 from "./ListStudentsMiPE.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports